
import FooterPage from '@/components/Pages/FooterPage'
import { BASE_URL } from '@/util/api';
async function getHomeData(slug:any) {
  const res = await fetch(`${BASE_URL}${slug}/`,
      { cache: 'no-store' }
      );
    if (!res.ok) {
      throw new Error('Failed to fetch FAQ data');
    }
    return res.json();
  }

const Footer = async() => {
    const basic_details=await getHomeData('basic-details?footer=true');
    return (
        <FooterPage basic_details={basic_details}/>
    )
}
export default Footer